<script setup lang="ts">
const props = defineProps<{
	hasOr?: boolean;
	isVertical?: boolean;
}>();
</script>

<template>
	<span
		class="divider"
		:class="[{
			'divider--is-line': !props.hasOr,
			'divider--vertical': props.isVertical,
		}]"
	>
		<span class="divider__label" v-if="props.hasOr">or</span>
	</span>
</template>

<style scoped lang="scss">
@layer hm-components
{
	.divider
	{
		@include flex(null, center, var(--spacing-xs));
		width:100%;
		color:var(--border-secondary);
		@include text-caption;

		&::before,
		&::after
		{
			content:'';
			flex-grow:1;
			border-block-start:1px solid currentColor;
		}

		&__label
		{
			color:var(--c-caption);
		}

		&--is-line
		{
			&::after
			{
				display:none;
			}
		}
		&--vertical
		{
			width:auto;

			&::before
			{
				height:100%;
				border-block-start:0;
				border-inline-start:1px solid currentColor;
			}
		}
	}
}
</style>
